module.exports = __webpack_public_path__ + "img/church-flier.bfb938fa.jpg";